import {
    GCP_FIREDRILL_COUNTRY_CODE,
    ROW_COUNTRY_CODE,
} from '../constants/safemode.constants';

export interface SafeModeResponse {
    countryCode: string;
    status: string;
}

export type SafeModeParser = (resp: Response) => Promise<SafeModeResponse>;

type Status = {
    [key: string]: {
        status: string;
        platforms?: string[];
    };
};

const extractGCPStatus = (
    data: Status,
    currentDevice: string,
    countryCode: string,
) => {
    const defaultCountryCode = data[ROW_COUNTRY_CODE]?.status || 'GREEN';
    const selectedCountryCode = data[countryCode];

    return {
        countryCode: countryCode || ROW_COUNTRY_CODE,
        status: selectedCountryCode?.platforms?.includes(currentDevice)
            ? selectedCountryCode.status
            : defaultCountryCode,
    };
};

export const parseSafeModeStatusGCPFireDrill: SafeModeParser = (
    resp: Response,
) =>
    resp.json().then(data => {
        const currentDevice = 'web';

        return extractGCPStatus(
            data,
            currentDevice,
            GCP_FIREDRILL_COUNTRY_CODE,
        );
    });

export const parseSafeModeStatusGCP: SafeModeParser = (resp: Response) =>
    resp.json().then(data => {
        const currentDevice = 'web';

        return extractGCPStatus(
            data,
            currentDevice,
            resp.headers.get('dazn-country')?.split(',')[0] || '',
        );
    });
